import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import { ButtonGroup, GuideTypographyLine } from "../../CellComponent";
import { LastCard } from "../common";

export const Content_10_1_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  Header1("typography_3"),
  Instruction("typography_4"),
  Instruction("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),
  Instruction("typography_8"),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),
  Instruction("typography_13"),
  Instruction("typography_14"),
  Instruction("typography_15"),

  InstructionWithContent(`typography_16`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 그 생각이 나의 진짜 모습이자 진실이라고 굳게 믿는다.",
          },
          {
            text: "B. 나와 무관한 주변의 소리로 여기며 판단 없이 지그시 관찰한다.",
          },
          {
            text: "C. 왜 그런 생각을 했는지 스스로를 탓하며 분석한다.",
          },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz1_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_17"),

  Header1("typography_18"),
  Instruction("typography_19"),
  Instruction("typography_20"),
  Instruction("typography_21"),

  InstructionWithContent(`typography_22`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 상태가 악화되었다고 판단하고 즉시 훈련을 그만둔다.",
          },
          {
            text: "B. 더 쉽고 빠른 다른 치료법이 없는지 찾아 나선다.",
          },
          {
            text: "C. 자연스러운 과정이라 여기고 훈련을 계속한다.",
          },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz2_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 2 }],
    }),
  ]),

  Instruction("typography_23"),
  Instruction("typography_24"),

  Header1("typography_25"),
  Instruction("typography_26"),

  InstructionWithContent(`typography_27`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 당장의 불안과 스트레스를 잊게 해주는 도피처",
          },
          {
            text: "B. 근본적으로 나 자신을 변화시키는 내면의 힘",
          },
          {
            text: "C. 누군가의 조언으로 내 문제를 해결하는 것",
          },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz3_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_28"),

  ...LastCard,
];
